import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllAdvertisersForSearch.graphql';
import { Query, QueryallAdvertisersForSearchArgs } from '../../__generated__/globalTypes';

export const useAllAdvertisersForSearchQuery = (
  options?: QueryHookOptions<Query, QueryallAdvertisersForSearchArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallAdvertisersForSearchArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllAdvertisersForSearchLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallAdvertisersForSearchArgs>
): QueryResult<Query, QueryallAdvertisersForSearchArgs> & {
  getAllAdvertisersForSearch: LazyQueryExecFunction<Query, QueryallAdvertisersForSearchArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllAdvertisersForSearch, result] = useLazyQuery<Query, QueryallAdvertisersForSearchArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllAdvertisersForSearch, ...result };
};

export const useAllAdvertisersForSearchPromiseQuery = () => {
  const client = useApolloClient();

  const getAllAdvertisersForSearch = useCallback(
    (options?: Omit<QueryOptions<QueryallAdvertisersForSearchArgs, Query>, 'query'>) =>
      client.query<Query, QueryallAdvertisersForSearchArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllAdvertisersForSearch };
};
// Suspense Query Hooks
export const useAllAdvertisersForSearchSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallAdvertisersForSearchArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallAdvertisersForSearchArgs>(QUERY, {
    ...options
  });

  return result;
};
